import type { FaireProductEntity } from "../../entity_types/product";

export const p_s34tsg8a8x: FaireProductEntity = {
  token: "p_s34tsg8a8x",
  type: "product",
  name: "Thank You Very Much Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bace05506556505c7d64238b3f5732a792c6e44d1726ace16d3bfd3761b2f93a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85df84e7eb06a9860d81df5431122657f4ec3391a81210a92ab4422dbf06636a.jpeg",
    "https://cdn.faire.com/fastly/45fd0e1fb8da8713cb5c48176e4ea0cecf36658bda99d7c60435c5ce9ca76983.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:30.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
